import { INICIALITZAR, OBTENIR_MUNICIPIS } from "../actions/actionTypes";

const ESTAT_INICIAL = [];

const municipisReducer = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_MUNICIPIS}_EN_CURS`:
      return {
        ...state,
        peticioEnCurs: true
      };

    case `${OBTENIR_MUNICIPIS}_SUCCESS`:
      return {
        ...state,
        municipis: action.payload,
        peticioEnCurs: false
      };

    case `${OBTENIR_MUNICIPIS}_ERROR`:
      return {
        ...state,
        peticioEnCurs: false,
        error: action.error
      };

    default:
      return state;
  }
};

export default municipisReducer;

const getPeticioEnCurs = state => state.peticioEnCurs;
const totsMunicipis = state => state.municipis;

export const getMunicipis = state => {
  const municipis = totsMunicipis(state);

  if (!municipis) {
    return null;
  }
  if (!municipis.municipis) {
    return null;
  }
  return municipis.municipis;
};

export const getPeticioMunicipisEnCurs = state => {
  const peticioEnCurs = getPeticioEnCurs(state);
  if (typeof peticioEnCurs !== "boolean") {
    return null;
  }
  return peticioEnCurs;
};

export const getPeticioMunicipisError = state => state.error;
